import { createContext, useContext, useEffect, useState } from 'react';
import { onSnapshot, doc } from 'firebase/firestore';
import { db } from './firebase_init';
import { DEFAUL_CURRENCY_LANG, DEFAULT_LANG } from '../Localization/routesLocalized';
import { useLanguage } from '../Localization/LanguageLayout';

const FirestoreWebContext = createContext(null);

export const FirestoreWebProvider = ({ children }) => {
    const [data, setData] = useState(null);
    const language = useLanguage();

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, 'settings', 'web'), (snapshot) => {
            if (snapshot.exists()) {
                const webData = snapshot.data();
                setData(webData);
            }
        });
        return () => unsubscribe();
    }, []);

    const getSortedFromLowest = (arr) => {
        return [...arr].sort((a, b) => a.c - b.c);
    }

    const getLocalPrices = (lang = language) => {
        if (!data?.prices) return null;
        const prices = data.prices;

        const sd = prices[lang] || prices[DEFAUL_CURRENCY_LANG];
        if (sd) {
            return getSortedFromLowest(sd);
        }
        const first = Object.keys(prices)[0];
        return getSortedFromLowest(data[first]);
    }

    return (
        <FirestoreWebContext.Provider value={{ data, getLocalPrices }}>
            {children}
        </FirestoreWebContext.Provider>
    );
};

export const useFirestoreWebData = () => useContext(FirestoreWebContext);

export const useLocalPrices = () => {
    const [prices, setPrices] = useState(null);
    const fwd = useFirestoreWebData();
    const language = useLanguage();
    const { getLocalPrices } = fwd || {};

    useEffect(() => {
        if (!getLocalPrices) return;
        const pricesLoc = getLocalPrices(language);
        setPrices(pricesLoc);
    }, [language, getLocalPrices]);

    return prices;
}
